import { render, staticRenderFns } from "./perfect-user.vue?vue&type=template&id=d4485d0c&scoped=true"
import script from "./perfect-user.vue?vue&type=script&lang=ts"
export * from "./perfect-user.vue?vue&type=script&lang=ts"
import style0 from "./perfect-user.vue?vue&type=style&index=0&id=d4485d0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4485d0c",
  null
  
)

export default component.exports